import { isUuid } from 'lib/isUuid'

/**
 * space_id / encrypted_id のいずれかから canonical UUID を選ぶ。
 */
export function resolveCanonicalSpaceUuid(
  spaceId?: string | null,
  encryptedId?: string | null
): string | undefined {
  const trimmedSpaceId = spaceId?.trim()
  if (isUuid(trimmedSpaceId)) {
    return trimmedSpaceId
  }

  const trimmedEncryptedId = encryptedId?.trim()
  if (isUuid(trimmedEncryptedId)) {
    return trimmedEncryptedId
  }

  return undefined
}
